import { render, staticRenderFns } from "./listagem-paineis.vue?vue&type=template&id=5968a430&"
import script from "./listagem-paineis.vue?vue&type=script&lang=js&"
export * from "./listagem-paineis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports